import { render, staticRenderFns } from "./staticWebsiteSetting.vue?vue&type=template&id=a70ecb8e&scoped=true"
import script from "./staticWebsiteSetting.vue?vue&type=script&lang=js"
export * from "./staticWebsiteSetting.vue?vue&type=script&lang=js"
import style0 from "./staticWebsiteSetting.vue?vue&type=style&index=0&id=a70ecb8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70ecb8e",
  null
  
)

export default component.exports